import React from 'react';
import { Text } from 'react-native-web';
import PropTypes from 'prop-types';
import * as Animatable from 'react-native-animatable';

// Configs
import GLOBAL from '../configs/config_global';

export function EmptyTextSection(props) {
    const { title, subTitle, style } = props;
    return(
        <Animatable.View
            animation={'fadeIn'}
            style={[{ flex: 1, alignItems: 'center', justifyContent: 'center', paddingHorizontal: 24 }, style]}>
            <Text style={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO, textAlign: 'center', marginHorizontal: 48, fontSize: 24, fontWeight: 'bold' }}>
                {title}
            </Text>

            <Text style={{ color: GLOBAL.COLOR.BASIC.NEUTRAL_DARK_GREY, textAlign: 'center', marginTop: 16, fontSize: 18, lineHeight: 26 }}>
                {subTitle}
            </Text>
        </Animatable.View>
    )
}

// region Props
EmptyTextSection.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string
}

EmptyTextSection.defaultProps = {
    title: 'Nothing Here',
    subTitle: 'Do something about it'
}
// endregion
